import PropTypes from 'prop-types';
import SearchBoxMobile from '../SearchBox/SearchBoxMobile';
import SearchBoxMenuItemType from '../SearchBox/SearchBoxMenuItemType';

export default function LogsPageSearchBoxMobile({
    className,
    placeholder,
    onSearchTextChange,
    onItemSelected,
    searchWords,
    items,
    selectedValue,
    searchText,
    showSearchResults,
    setShowSearchResults,
    setSearchParams,
}) {
    return (
        <SearchBoxMobile
            className={className}
            onItemSelected={onItemSelected}
            onSearchTextChange={onSearchTextChange}
            placeholder={placeholder}
            items={items}
            searchWords={searchWords}
            selectedValue={selectedValue}
            searchText={searchText}
            showSearchResults={showSearchResults}
            setShowSearchResults={setShowSearchResults}
            setSearchParams={setSearchParams}
        />
    );
}
LogsPageSearchBoxMobile.propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            type: PropTypes.oneOf(Object.values(SearchBoxMenuItemType)),
        }),
    ),
    onItemSelected: PropTypes.func.isRequired,
    onSearchTextChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    searchText: PropTypes.string,
    searchWords: PropTypes.arrayOf(PropTypes.string),
    selectedValue: PropTypes.string,
    setSearchParams: PropTypes.func,
    setShowSearchResults: PropTypes.func,
    showSearchResults: PropTypes.bool,
};
